// @flow
import { camelCaseToSnakeCase } from 'utils/string';
import type { State } from '../redux/main';

const extractFilters = (searchFacets, filters: Object) => {
  const result = {};

  Object.keys(filters).forEach(filterKey => {
    let value = filters[filterKey];
    if (searchFacets[filterKey] && value === searchFacets[filterKey].options) {
      value = 'ALL';
    }
    result[`filter_${camelCaseToSnakeCase(filterKey)}`] = value;
  });
  return result;
};

export const extractLocationProperties = (location: SearchLocation) => ({
  location_geo_type: location.geoType,
  location_latitude: location.latitude,
  location_longitude: location.longitude,
  location_state: location.stateCode,
  location_text: location.text
});

const getMainSearchTrackingData = ({
  mainSearch: {
    initialized,
    searchFacets,
    filters,
    query,
    pageIndex,
    resultsByPage
  },
  currentUser,
  searchRadius: { value: radius }
}: State) => {
  if (initialized && currentUser && currentUser.searchLocation) {
    const { searchLocation } = currentUser;
    const results = resultsByPage[pageIndex.toString()] || {};
    return {
      current_page: pageIndex + 1,
      geo_location_enabled: !!searchLocation.latitude,
      ...extractFilters(searchFacets, filters),
      search_query: query,
      search_radius: radius,
      number_of_results: results.nbHits,
      number_of_pages: results.nbPages,
      ...extractLocationProperties(searchLocation)
    };
  }
  return {};
};

export default getMainSearchTrackingData;
